const heroTabs = document.querySelectorAll('.capture.hero nav a[href^="#"]');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

heroTabs.forEach((tab) => {
  tab.addEventListener('click', (event) => {
    const target = document.querySelector(tab.getAttribute('href'));

    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
      block: 'start'
    });
    history.pushState(null, '', tab.getAttribute('href'));
  });
});

const terrains = [
  ["SURFACE 01 / 03", "CITY", "ASPHALT / TOKYO"],
  ["SURFACE 02 / 03", "GRAVEL", "LOOSE STONE / BETWEEN"],
  ["SURFACE 03 / 03", "WILD", "EARTH / KENYA"]
];

document.querySelector("[data-stage]")?.addEventListener("gravel:phase", ({ detail }) => {
  const [number, name, note] = terrains[detail.phase];
  const terrainName = document.querySelector(".terrain-name");

  if (terrainName) {
    terrainName.querySelector("small").textContent = number;
    terrainName.querySelector(".terrain-name__title").textContent = name;
    terrainName.querySelector(".terrain-name__title + p").textContent = note;
  }

  document.querySelectorAll("[data-surface]").forEach((item, index) => {
    item.classList.toggle("is-active", index === detail.phase);
  });
});
